import { render } from "./MoneyTransferModal.vue?vue&type=template&id=36786589&scoped=true&ts=true"
import script from "./MoneyTransferModal.vue?vue&type=script&lang=ts"
export * from "./MoneyTransferModal.vue?vue&type=script&lang=ts"

import "./MoneyTransferModal.vue?vue&type=style&index=0&id=36786589&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36786589"]])

export default __exports__